import { AppLayout } from "../shared";
import MasterOrgAdvertisementAnalytics from "../MasterOrg/MasterOrgAdvertisementAnalytics";

const MasterOrgAdvertisementAnalytics_layout = ({ props, setIsLoaded }) => (
  <AppLayout props={props}>
    <MasterOrgAdvertisementAnalytics props={props} setIsLoaded={setIsLoaded} />
  </AppLayout>
);

export default MasterOrgAdvertisementAnalytics_layout;
